import DotNetObject = DotNet.DotNetObject;
import { Product } from '@crimsontide/core/client/interfaces';

export const ProductService = (() => {
  let dotNetObj: DotNetObject;

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getProducts = async (
    customerId: string, 
    siteId: string, 
    jobInvoiceLineId: string, 
    quoteLineId: string, 
    invoiceLineId: string): Promise<Product[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<Product[]>('GetAsync', customerId, siteId, jobInvoiceLineId, quoteLineId, invoiceLineId);
    } else {
      throw 'Product DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getProducts,
  };
})();
